import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useMobileNav = () => {
  const location = useLocation();

  useEffect(() => {
    const handleShowHeader = () => {
      document.body.classList.add('mobile-nav-active');
      document.querySelector('.mobile-nav-hide')?.classList.remove('d-none');
      document.querySelector('.mobile-nav-show')?.classList.add('d-none');
    };

    const handleHideHeader = () => {
      document.body.classList.remove('mobile-nav-active');
      document.querySelector('.mobile-nav-hide')?.classList.add('d-none');
      document.querySelector('.mobile-nav-show')?.classList.remove('d-none');

      // zatvori sve dropdownove
      document.querySelectorAll('.dropdown.active')
        .forEach(d => d.classList.remove('active'));

      document.querySelectorAll('.dropdown .dropdown-active')
        .forEach(dm => dm.classList.remove('dropdown-active'));

      document.querySelectorAll('.dropdown .dropdown-indicator')
        .forEach(ind => {
          ind.classList.remove('bi-chevron-up');
          ind.classList.add('bi-chevron-down');
        });

      // dodatak: makni aktivnu klasu sa svih <a> linkova u dropdownima
      document.querySelectorAll('.dropdown > a.active')
        .forEach(a => a.classList.remove('active'));
    };

    // Delegacija eventa za dropdown
    const handleDropdownClick = (event) => {
      const target = event.target.closest('.dropdown > a');
      if (!target) return;

      if (!document.body.classList.contains('mobile-nav-active')) return;

      event.preventDefault();

      // Toggle klase
      target.classList.toggle('active');
      const dropdownMenu = target.nextElementSibling;
      if (dropdownMenu) dropdownMenu.classList.toggle('dropdown-active');

      const dropDownIndicator = target.querySelector('.dropdown-indicator');
      if (dropDownIndicator) {
        dropDownIndicator.classList.toggle('bi-chevron-up');
        dropDownIndicator.classList.toggle('bi-chevron-down');
      }
    };

    const mobileNavShow = document.querySelector('.mobile-nav-show');
    const mobileNavHide = document.querySelector('.mobile-nav-hide');
    const navbar = document.getElementById('navbar');

    // Event listeneri
    mobileNavShow?.addEventListener('click', handleShowHeader);
    mobileNavHide?.addEventListener('click', handleHideHeader);

    // Delegacija na navbar
    navbar?.addEventListener('click', handleDropdownClick);

    // Sakrij header + resetuj dropdownove kad se promeni ruta
    handleHideHeader();

    return () => {
      mobileNavShow?.removeEventListener('click', handleShowHeader);
      mobileNavHide?.removeEventListener('click', handleHideHeader);
      navbar?.removeEventListener('click', handleDropdownClick);
    };
  }, [location.pathname]);
};

export default useMobileNav;
